import { Map, fromJS } from 'immutable';

export function request(state, { marketId }) {
    return state.setIn([ 'add-all-selections', marketId ], Map({
        state: 'IN_PROGRESS'
    }));
}

export function error(state, { marketId, errors }) {
    return state.setIn([ 'add-all-selections', marketId ], Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));
}

export function finish(state, { marketId, selections }) {
    let sel = state.getIn([ 'items', marketId, 'selections' ]).toArray().concat(selections);
    return state
        .setIn([ 'add-all-selections', marketId ], Map({
            state: 'FINISHED'
        }))
        .mergeIn([ 'items', marketId, 'selections' ], fromJS(sel));
}
